module.exports = __webpack_public_path__ + "img/pay-adyen.a6087d7.png";